<template>
  <div class="equipment-info-page">
    <!-- 分页 -->
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: () => 1,
    },
    size: {
      type: Number,
      default: () => 10,
    },
    total: {
      type: Number,
      default: () => 0,
    },
  },
  data () {
    return {};
  },
  computed: {
    currentPage: {
      get () {
        return this.page;
      },
      set (val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get () {
        return this.size;
      },
      set (val) {
        this.$emit("update:size", val);
      },
    },
  },
  methods: {
    // 点击页码
    handleSizeChange (val) {
      this.$emit("pageChange");
    },
    handleCurrentChange (val) {
      this.$emit("pageChange");
    },
  },
};
</script>

<style scoped lang="scss">
.equipment-info-page {
  display: flex;display:-webkit-flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
